// extracted by mini-css-extract-plugin
export default {"menu":"MenuWithIcons_menu__KfkWY"};